module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 26 18",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#youtube",
      toString: function () {
        return this.url;
      }
    }